export default __webpack_public_path__ + "static/media/404.9f82892d.jpg";